//PC
function isPC(){
  return $(window).width() > 749;
}

// 現在のページのURLを取得(絶対パス)
function getCurrentUrl(){
  const url = document.location.protocol + '//' + document.location.host + document.location.pathname;
  return url;
}

// HOMEのURLを取得(絶対パス)
function getHomeUrl(){
  const pathname = getHomeUrlPathName();
  const url = document.location.protocol + '//' + document.location.host + pathname;
  return url;
}

// HOMEのURLを取得（pathnameからの絶対パス）
function getHomeUrlPathName(){
  const homeUrl = '/';
  return homeUrl;
}

// トップページか判定
function isPageTop(){
  let homeUrlPathName = '/';
  // 最後のスラッシュを消す（デモ環境対策）
  homeUrlPathName = homeUrlPathName.slice(0, homeUrlPathName.length-1);
  const regex = '^' + homeUrlPathName + '\/?$';
  return Util.isPageRegex(regex);
}

$(function() {

  //ヘッダーの縮小化
  $(window).on('scroll', minimizeHeaderOnScroll );

  //ヘッダー検索キーワードの横スクロール処理
  horizontalDraggable('#search-modal__keyword');

  //続きを読む
  showMoreDetailsContent();

  //シェアボタンのポップアップを表示
  showPopupShare();

  //シェアボタン URLコピー
  initCopyUrlButton();

  //コレクションリストの横スクロール処理
  horizontalDraggable('.collection-category-list-wrapper');

  // グローバルナビゲーション制御
  controlGlobalNavigation();

  //外部リンクアニメーション
  externaLinkAnimation();

  // 数量選入力時のmin/maxを強制適用する
  validateQuantityRange();

  //Enterキーのフォーム送信防止
  inputNoEnterSend();

  //ページ内リンク自動生成
  autoPagenavi('.js-ap-headline');

  //ページ内リンク位置調整
  pageLinkPosition();

  //ページ上部にスクロールするボタン
  scrollPagetop();

  //スマホ
  //if( !isPC() ){
  //  //画面下部のメニューの表示制御
  //  $(window).on('scroll', controlSpBottomNavFixed);
  //}
  
  //トップページ
  if( isPageTop() ){
    //ヘッダーの色変更処理
    toggleHeaderColorOnScroll();
    $( window ).on( 'scroll', toggleHeaderColorOnScroll );

    //タブ切り替え（click）
    $( '.js-tab-click' ).on( 'click', function() {
      tabSwitch( $( this ) );
    });
  
    //タブ切り替え（hover）
    $( '.js-tab-hover' ).hover( function() {
      tabSwitch( $( this ) );
    });

    //インスタフィードの親要素にclass付与
    addClassToInstaFeedParent();
    
  //コレクション・検索ページ
  } else if ($('.page-collection').length || getCurrentUrl().match(/\/search$/)) {
    // 画面幅が750px以上かどうかを判定するメディアクエリを作成
    const mediaQuery = window.matchMedia('(min-width: 750px)');
    // ページ読み込み時にメディアクエリの条件に応じて処理を実行
    handle(mediaQuery);
    // ウィンドウサイズが変更されるたびにメディアクエリの状態を監視し、処理を実行
    mediaQuery.addListener(handle);
    /**
     * メディアクエリの状態に応じた処理を実行する関数
     * @param {MediaQueryList} mm - メディアクエリの状態を表すオブジェクト
     */
    function handle(mm) {
      // 画面幅がモバイル表示）の場合
      if (!mm.matches) {
        //スマホ時、コレクションページのスクロール固定
        //collectionScrollFixed();
      }
    }
    // 絞り込みボタンの表示
    showFacetBtn();
    
  //商品ページ
  } else if ($('.page-product').length) {
    //商品バリエーション情報の更新
    if($('#variant-zaiko-status').length) {
      // バリエーションの変更を検知して実行
      $(document).on('change','input.product-variant-id', function() {
        updateVariationCustomInfo();
      });
    }
    //タブ切り替え（click）
    $('.js-tab-click').on('click', function () {
      tabSwitch($(this));
    });

    //支払い方法、配送と返品、ラッピングのドロワー表示
    initProductDetailDrawer();

    //商品について、お手入れ方法、サイズ・仕様注意事項のトグル化
    initProductAccordionToggle();
    
  //FAQページ
  }else if( getCurrentUrl().match(/\/pages\/faq/) ){
    //FAQのコンテンツの開閉処理
    toggleFaqContents()

    // 問い合わせフォーム
  }else if( getCurrentUrl().match(/\/pages\/contact/) ){
    // メッセージにパラメータ内容をセット
    setProductInfoToMessage();
  }

});


$( window ).on( 'load', function(){
  
  // タッチデバイスでない場合の処理
  if ( !('ontouchstart' in window || navigator.maxTouchPoints) ) {
    //特定のエリアでカーソル変更
    customizeCursorOnHover('.shopify-block-ultimate-recently-viewed .glider-contain', '.custom-cursor-viewed');
    customizeCursorOnHover('.custom-cursor-detail-area', '.custom-cursor-detail');
    customizeCursorOnHover('.custom-cursor-slider-area', '.custom-cursor-slider');
    customizeCursorOnHover('.product-media-container', '.product__media-icon');
  }
  
  //トップページ
  if( illm.common.isPageTop() ){
    //BESTSELLERのスライダー
    productlistSlider( '.top-bestseller-swiper' );
    
    //LIMITEDの画像切り替え
    limitedImgaeSlide();
 
  //商品ページ
  }else if( getCurrentUrl().match(/\/products\//) || getCurrentUrl().match(/\/products_preview$/) ){
    // 商品画像の矢印ボタンの処理
    processingImageArrowButton();
  
    //RECOMMENDのスライダー
    productlistSlider( '.recommend-swiper' );
  
    //お気に入り追加ボタンの位置制御
    controlAddFavoriteButton();

    // スタッフスタート向けのスクロール処理
    $('.js-draggable section > div,.product-other-products-list').mousedragscrollable();


  // FEATURE詳細
  }else if ( getCurrentUrl().match(/\/feature\//) ){
    //RECOMMENDのスライダー
    featureRecommendSlider();
  
  // カート画面
  }else if ( getCurrentUrl().match(/\/cart$/) ){
    //アクセサリーのスライダー
    productlistSlider( '.cart-accessories-swiper' );
    // トグルコンテンツ
    cartToggleBtns();
  }

    // コレクションページ with MV
  if ($('#itemlist-mv-contents').length) {
    //ヘッダーの色変更処理
    togglCollectioneHeaderColorOnScroll();
    $( window ).on( 'scroll', togglCollectioneHeaderColorOnScroll );

    // BESTSELLER swiper
    productlistSlider( '.collection-bestseller-swiper' );

    $('.js-tab-click').on('click', function() {
      tabSwitch($(this));
    });
    $('.js-tab-hover').hover(function() {
      tabSwitch($(this));
    });

  }

  // GIFTページ
  if ($('#gift-headcontents').length) {
    // BESTSELLER swiper
    productlistSlider( '.gift-bestseller-swiper' );
    productlistSlider(".collection-bestseller-swiper");

    $('.js-tab-click').on('click', function() {
      tabSwitch($(this));
    });
    $('.js-tab-hover').hover(function() {
      tabSwitch($(this));
    });
  }



});

/*
 * ヘッダーの色変更処理
 */
function toggleHeaderColorOnScroll(){
  const header = $( '.announcement-bar-section, .section-header' );//ヘッダー要素
  const mvHeight = $( '.section-mainvisual' ).outerHeight();//メインバナーの高さを取得

  //メインバナーよりも下にスクロールしたらヘッダーはデフォルトの黒表示
  if ( $( window ).scrollTop() > mvHeight ) {
    header.addClass( 'js-color-default' );
    
  //メインバナーにかぶっているときは、ヘッダーは白表示
  } else {
    header.removeClass( 'js-color-default' );
  }
}
function togglCollectioneHeaderColorOnScroll(){
  const header = $( '.announcement-bar-section, .section-header' );//ヘッダー要素
  const mvHeight = $( '.item-mv' ).outerHeight();//メインバナーの高さを取得

  //メインバナーよりも下にスクロールしたらヘッダーはデフォルトの黒表示
  if ( $( window ).scrollTop() > mvHeight ) {
    header.addClass( 'js-color-default' );
    
  //メインバナーにかぶっているときは、ヘッダーは白表示
  } else {
    header.removeClass( 'js-color-default' );
  }
}
/*
 * ヘッダーの縮小化
 */
function minimizeHeaderOnScroll(){
  //ちょっとスクロールしたらヘッダー縮める
  if ( $(window).scrollTop() > 20 ) {
    $( '.section-header' ).addClass( 'js-scroll' );
  }else{
    $( '.section-header' ).removeClass( 'js-scroll' );
  }
}

/*
 * タブ切り替え
 */
function tabSwitch( targetTab ){
  const tabContainer = targetTab.parents( '.js-tab__container' );
  
  //一旦リセットして、該当のタブをアクティブ化
  tabContainer.find( '.js-tab__button, .js-tab__content' ).removeClass( 'active' );
  targetTab.addClass( 'active' );
  
  //該当コンテンツをアクティブ化
  const targetTabIndex = tabContainer.find( '.js-tab__button' ).index( targetTab );
  tabContainer.find( '.js-tab__content' ).eq( targetTabIndex ).addClass( 'active' );
}

/*
 * BESTSELLERのスライダー / RECOMMENDのスライダー / CARTのアクセサリースライダー
 */
function productlistSlider( targetSlider ){
  const mySwiper = new Swiper(targetSlider, {
    slidesPerView: 1.9,
    spaceBetween: 35,
    freeMode: {
      enabled: true,//自由にドラッグ（スワイプ）できるようにする
    },
    breakpoints: {
      //デバイス750px以上の場合
      750: {
        slidesPerView: 4.3,
        spaceBetween: 45,
        scrollbar: {
          hide: true,
        }
      }
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true 
    }
  });

  //スライダー実行後にコンテンツ表示
  $( '.bestseller-content-container' ).removeClass( 'is--hidden' );
}

/*
 * FEATUREのRECOMMENDのスライダー
 */
function featureRecommendSlider(){
  
  //メイン商品画像のスライド
  const mvSwiper = new Swiper('.recommend-visual-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });

  //商品リストのスライド
  const recommendSwiper = new Swiper('.recommend-item-swiper', {
    slidesPerView: 2.1,
    spaceBetween: 20,
    freeMode: {
      enabled: true,//自由にドラッグ（スワイプ）できるようにする
    },
    breakpoints: {
      //デバイス750px以上の場合
      750: {
        slidesPerView: 'auto',
        spaceBetween: 15,
        scrollbar: {
          hide: false,
        }
      }
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true 
    }
  });

  //スライダー実行後にコンテンツ表示
  $( '.feature-recommend-mv-container' ).removeClass( 'hidden' );
  $( '.feature-recommend-items-container' ).removeClass( 'hidden' );
}

/*
 * ヘッダー検索キーワードの横スクロール処理
 */
function horizontalDraggable( selector ){
  const $targetSelector = $( selector );// 対象となる要素のjQueryオブジェクト
  let draggingElement; // ドラッグ中の要素を追跡する変数
  
  $targetSelector.each( function( index,element ) {
    //マウスが押された時に発動
    $( element ).mousedown( function( event ) {
      event.preventDefault();// デフォルトの動作をキャンセル
      draggingElement = $( element );
      $( element ).data({
        down: true,// ドラッグ中フラグ
        x: event.clientX,// ドラッグ開始位置のX座標
        y: event.clientY,// ドラッグ開始位置のY座標
        left: $( element ).scrollLeft(),// ドラッグ開始時のスクロール位置（左）
        top: $( element ).scrollTop()// ドラッグ開始時のスクロール位置（上）
      });
    });
  });

  //マウスが移動しているときに発生
  $(document).mousemove( function( event ) {
    if( $( draggingElement ).data("down") ) {
      event.preventDefault();// デフォルトの動作をキャンセル
      $( draggingElement ).scrollLeft( 
        $( draggingElement ).data( "x" ) + $( draggingElement ).data( "left" ) - event.clientX
      );
      $( draggingElement ).scrollTop( 
        $( draggingElement ).data( "y" ) + $( draggingElement ).data( "top" ) - event.clientY
      );
    }
    
  //マウスボタンが放されたときに発生
  }).mouseup(function( event ) {
    $( draggingElement ).data( "down", false );// ドラッグ中フラグをリセット
  });
}

/*
 * インスタフィードの親要素にclass付与
 */
function addClassToInstaFeedParent(){
  //アプリ側で自動で出力しているタグでHTML編集が不可のため、JSでclassを付与する処理
  $( '.instafeed_app__img' ).parent( 'div' ).addClass( 'instafeed_app__container' );
}

/*
 * 続きを読む
*/
function showMoreDetailsContent() {
  const $wrapperContent = $('.readmore-wrap');//対象のエリア
  const $moreButton = $wrapperContent.find('.readmore');//続きを読むボタン
  $moreButton.on('click',function(){
    const showContent = $(this).siblings('.readmore-content');
    showContent.toggleClass('is--open');
    if(showContent.hasClass('is--open')){
      const showContentHeight = showContent.get(0).scrollHeight;
      showContent.css('height', showContentHeight);
      $(this).text('元に戻す');
    }else{
      showContent.css('height','');
      $(this).text('...続きを見る');
    }
  });
}

/*
 * シェアボタンのポップアップを表示
 */
function showPopupShare() {
  const popupShareContent = $('.js-sns-popup');//表示するポップアップ
  const popupShareBtn = $('.js-sns-popup-btn');//対象のボタン

  //ボタンをクリック時、クリックイベント停止してポップアップ表示
  popupShareBtn.on('click',function(event){
    event.stopPropagation();
    popupShareContent.addClass('is--show');
  });

  //ポップアップ以外の場所をクリックしたら、閉じる
  $(document).click(function(event) {
    if(!$(event.target).closest(popupShareContent,popupShareBtn).length) {
      popupShareContent.removeClass('is--show');
    } 
  });
}

/*
 * シェアボタン URLコピー
 */
function initCopyUrlButton() {
  $('.js-copy-url').on('click', function(e) {
    e.preventDefault();

    const url = $(this).data('url');

    navigator.clipboard.writeText(url)
      .then(function() {
        alert('URLをコピーしました');
      })
      .catch(function(err) {
        console.error('コピーに失敗しました', err);
      });
  });
}

/*
 * 商品画像の矢印ボタンの処理
 */
function processingImageArrowButton(){
  //動作
  let activeIndex;

  //「＜」の矢印ボタンをクリックしたとき
  $(document).on("click", ".customize-prev-btn", function () {
    //矢印ボタンを初期化
    $('.customize-prev-btn, .customize-next-btn').removeClass('disable');
    
    // アプリが複製したスライダーかどうかチェック
    if($(this).parent().hasClass('starapps')) {
      //カレント画像が何番目かを取得
      activeIndex = $('.thumbnail-slider.starapps .thumbnail[aria-current]').parent('.thumbnail-list__item').index('.thumbnail-slider.starapps .thumbnail-list__item');
      //一枚目の場合はなにもしない
      if( activeIndex == 0 ){
        //「＜」の矢印ボタンを押せなくなる
        $(this).addClass('disable');
        return;
      }else if( activeIndex == 1 ){
        //「＜」の矢印ボタンを押せなくなる
        $(this).addClass('disable');
      }
      //ひとつ前の画像を表示
      $('.thumbnail-slider.starapps .thumbnail-list__item').eq(activeIndex - 1).find('button').click();
    } else {
      //カレント画像が何番目かを取得
      activeIndex = $('.thumbnail[aria-current]').parent('.thumbnail-list__item').index('.thumbnail-list__item');
      //一枚目の場合はなにもしない
      if( activeIndex == 0 ){
        //「＜」の矢印ボタンを押せなくなる
        $(this).addClass('disable');
        return;
      }else if( activeIndex == 1 ){
        //「＜」の矢印ボタンを押せなくなる
        $(this).addClass('disable');
      }
      //ひとつ前の画像を表示
      $('.thumbnail-list__item').eq(activeIndex - 1).find('button').click();
    }
  });

  //「＞」の矢印ボタンをクリックしたとき
  $(document).on("click", ".customize-next-btn", function () {
    //矢印ボタンを初期化
    $('.customize-prev-btn, .customize-next-btn').removeClass('disable');
    
    // アプリが複製したスライダーかどうかチェック
    if($(this).parent().hasClass('starapps')) {
      //カレント画像が何番目かを取得
      activeIndex = $('.thumbnail-slider.starapps .thumbnail[aria-current]').parent('.thumbnail-list__item').index('.thumbnail-slider.starapps .thumbnail-list__item');
      //最後の画像の場合なにもしない
      if( activeIndex == $('.thumbnail-slider.starapps .thumbnail-list__item').length-1 ){
        //「＞」の矢印ボタンを押せなくなる
        $(this).addClass('disable');
        return;
      }else if(activeIndex == $('.thumbnail-slider.starapps .thumbnail-list__item').length-2){
        //「＞」の矢印ボタンを押せなくなる
        $(this).addClass('disable');
      }
      //ひとつ後の画像を表示
      $('.thumbnail-slider.starapps .thumbnail-list__item').eq(activeIndex + 1).find('button').click();
    } else {
      //カレント画像が何番目かを取得
      activeIndex = $('.thumbnail[aria-current]').parent('.thumbnail-list__item').index('.thumbnail-list__item');
      //最後の画像の場合なにもしない
      if( activeIndex == $('.thumbnail-list__item').length-1 ){
        //「＞」の矢印ボタンを押せなくなる
        $(this).addClass('disable');
        return;
      }else if(activeIndex == $('.thumbnail-slider.starapps .thumbnail-list__item').length-2){
        //「＞」の矢印ボタンを押せなくなる
        $(this).addClass('disable');
      }
      //ひとつ後の画像を表示
      $('.thumbnail-list__item').eq(activeIndex + 1).find('button').click();
    }
  });

  let touchStartX = null;
  let touchEndX = null;
  const swipeTarget = $('.media-slider').find('.slider__slide');
  // タッチ開始
  swipeTarget.on('touchstart', logSwipeStart);
  // スワイプ／フリック
  swipeTarget.on('touchmove', logSwipe);
  // タッチ終了
  swipeTarget.on('touchend', logSwipeEnd);

  //タッチ操作を記録する処理
  function logSwipeStart(event) {
    touchStartX = event.touches[0].pageX;
    action = 'touch';
  }
  
  //スワイプ操作記録する処理
  function logSwipe(event) {
    touchEndX = event.touches[0].pageX;
    action = 'swipe';
  }
  
  //スワイプ操作の開始を記録
  function logSwipeEnd(event) {
    //スワイプした場合
    if(action == 'swipe') {
      if( 10 < (touchEndX - touchStartX) ) {
        //矢印ボタンを初期化
        $('.customize-prev-btn, .customize-next-btn').removeClass('disable');
        
        // 右にスワイプ
        // アプリが複製したスライダーかどうかチェック
        if($(this).parents('.media-slider').hasClass('starapps')) {
          //カレント画像が何番目かを取得
          activeIndex = $('.thumbnail-slider.starapps .thumbnail[aria-current]').parent('.thumbnail-list__item').index('.thumbnail-slider.starapps .thumbnail-list__item');
          //一枚目の場合はなにもしない
          if( activeIndex == 0 ){
            //「＜」の矢印ボタンを押せなくなる
            $('.customize-prev-btn').addClass('disable');
            return;
          }else if( activeIndex == 1 ){
            //「＜」の矢印ボタンを押せなくなる
            $('.customize-prev-btn').addClass('disable');
          }
          //ひとつ前の画像を表示
          $('.thumbnail-slider.starapps .thumbnail-list__item').eq(activeIndex - 1).find('button').click();
        } else {
          //カレント画像が何番目かを取得
          activeIndex = $('.thumbnail[aria-current]').parent('.thumbnail-list__item').index('.thumbnail-list__item');
          //一枚目の場合はなにもしない
          if( activeIndex == 0 ){
            //「＜」の矢印ボタンを押せなくなる
            $('.customize-prev-btn').addClass('disable');
            return;
          }else if( activeIndex == 1 ){
            //「＜」の矢印ボタンを押せなくなる
            $('.customize-prev-btn').addClass('disable');
          }
          //ひとつ前の画像を表示
          $('.thumbnail-list__item').eq(activeIndex - 1).find('button').click();
        }
      } else if( -10 > (touchEndX - touchStartX) ){
        //矢印ボタンを初期化
        $('.customize-prev-btn, .customize-next-btn').removeClass('disable');

        // 左にスワイプ
        // アプリが複製したスライダーかどうかチェック
        if($(this).parents('.media-slider').hasClass('starapps')) {
          //カレント画像が何番目かを取得
          activeIndex = $('.thumbnail-slider.starapps .thumbnail[aria-current]').parent('.thumbnail-list__item').index('.thumbnail-slider.starapps .thumbnail-list__item');
          //最後の画像の場合なにもしない
          if( activeIndex == $('.thumbnail-slider.starapps .thumbnail-list__item').length-1 ){
            //「＞」の矢印ボタンを押せなくなる
            $('.customize-next-btn').addClass('disable');
            return;
          }else if(activeIndex == $('.thumbnail-slider.starapps .thumbnail-list__item').length-2){
            //「＞」の矢印ボタンを押せなくなる
            $('.customize-next-btn').addClass('disable');
          }
          //ひとつ後の画像を表示
          $('.thumbnail-slider.starapps .thumbnail-list__item').eq(activeIndex + 1).find('button').click();
        } else {
          //カレント画像が何番目かを取得
          activeIndex = $('.thumbnail[aria-current]').parent('.thumbnail-list__item').index('.thumbnail-list__item');
          //最後の画像の場合なにもしない
          if( activeIndex == $('.thumbnail-list__item').length-1 ){
            //「＞」の矢印ボタンを押せなくなる
            $('.customize-next-btn').addClass('disable');
            return;
          }else if(activeIndex == $('.thumbnail-slider.starapps .thumbnail-list__item').length-2){
            //「＞」の矢印ボタンを押せなくなる
            $('.customize-next-btn').addClass('disable');
          }
          //ひとつ後の画像を表示
          $('.thumbnail-list__item').eq(activeIndex + 1).find('button').click();
        }
      }
      
    //タッチの場合、矢印ボタンをクリック
    } else {
      $(this).find('button').click()
    }
  }
}

/*
 * 数量選入力時のmin/maxを強制適用する
 */
function validateQuantityRange(){
  //数量選択時に
  $('input[type="number"]').focusout(function() {
    //設定した値よりも小さい場合は最小値を設定
    if(typeof $(this).attr('min') !== "undefined" && parseInt($(this).val()) < parseInt($(this).attr('min'))){
      $(this).val($(this).attr('min'));
    }
    //設定した値よりも大きい場合は最大値を設定
    else if(typeof $(this).attr('max') !== "undefined" && parseInt($(this).val()) > parseInt($(this).attr('max'))){
      $(this).val($(this).attr('max'));
    }
    //空欄の場合は最小値を設定
    else if(typeof $(this).attr('min') !== "undefined" && $(this).val() === ''){
      $(this).val($(this).attr('min'));
    }
  });
}


/*
 * Enterキーのフォーム送信防止
 */
function inputNoEnterSend() {
  //「no-enter-send」classがあるinputタグ内ではEnterのフォーム送信は無効
  $("input.no-enter-send").keydown(function(event) {
    if ((event.which && event.which === 13) || (event.keyCode && event.keyCode === 13)) {
      return false;
    } else {
      return true;
    }
  });
}

/*
 * お気に入り追加ボタンの位置制御
 */
function controlAddFavoriteButton(){
  const addfavoriteButton = $('.product__info-container').find('wishlist-button-block');//アプリ出力のお気に入り追加ボタン
  if(addfavoriteButton.length) {
    //シェアボタンの横に追加
    addfavoriteButton.appendTo('.product-fav-btn');
  }
}


/*
 * ページ内リンク自動生成
 */
function autoPagenavi(target){
  const scrollSpeed = 500;
  let contentCount = 0;
  let LinklistHtml = '';

  $(target).each(function(){
    // 目次の項目数のカウントを増加
    contentCount ++;
    // 目次の項目を作成
    LinklistHtml += '<li><a href="#' + this.id + '">' + $(this).text() + '</a>';
  });

  // ページ内のh2タグが1つ以上の場合に目次を出力
  if(contentCount < 1){
    $('.js-ap-list-container').remove();
  } else {
    $('.js-ap-list').html(LinklistHtml);
  }

  // アンカー位置の調整
  const headerHeight = $('.header').height();//ヘッダーの高さを取得
  //作成したリンクをクリックしたら
  $('.js-ap-list a[href^="#"]').click(function () {
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    // ヘッダーの高さ分下げる
    let position = target.offset().top - headerHeight;
    $("body,html").animate({ scrollTop: position }, scrollSpeed, "swing");
    return false;
  });
}

/*
 * ページ内リンク位置調整
 */
function pageLinkPosition(){
  $('a[href^="#"]').not('.customer a').on('click', function (event) {
    // ページ内リンクで、かつそのIDを持つ要素がページ内に存在する場合のみ処理
    if (this.hash !== "" && $(this.hash).length) {
      event.preventDefault(); // デフォルトのアンカーリンクの動作をキャンセル

      var hash = this.hash;
      var headerHeight = 80; // 固定ヘッダーの高さに合わせて調整してください (例: 80px)

      // スクロール先の要素の位置からヘッダーの高さを引く
      var targetPosition = $(hash).offset().top - headerHeight;

      // HTMLとBODY要素をアニメーションでスクロール
      $('html, body').animate({
        scrollTop: targetPosition
      }, 800, function() { // 800はスクロール速度（ミリ秒）。調整可能。
        // スクロール完了後にURLのハッシュを更新
        // window.location.hash = hash;
      });
    }
  });
}


/*
 * 絞り込みボタンの表示切替
*/
function showFacetBtn() {

  // 1. 監視対象の要素（トリガー）
  const targetElement = document.getElementById('ProductGridContainer');

  // 2. クラスを付与する対象の要素
  const elementToToggle = document.querySelector('.mobile-facets__disclosure');

  // 要素が見つからない場合は処理を中断
  if (!targetElement) {
    return;
  }
  if (!elementToToggle) {
    return;
  }

  // 3. IntersectionObserver の設定
  const options = {
    root: null, // ビューポートを基準にする
    rootMargin: '0px',
    threshold: 0.01 // ほんの少し（1%）でも表示されたら発火
  };

  // 4. 要素が表示されたときに実行する処理
  const callback = (entries, observer) => {
    entries.forEach(entry => {
      // isIntersecting が true ＝ 画面内に表示された
      if (entry.isIntersecting) {

        // .is-show クラスを付与
        elementToToggle.classList.add('is-show');

        // 目的は達成したので、監視を停止する
        observer.unobserve(targetElement);
      }
    });
  };

  // 5. オブザーバーを作成して監視を開始
  const observer = new IntersectionObserver(callback, options);
  observer.observe(targetElement);
}


/*
 * スマホ時、コレクションページのスクロール固定
*/

function collectionScrollFixed() {
  // 固定対象
  const categoryLinklists = $('.collection-category-list-wrapper');
  const mobileFacetsButton = $('.mobile-facets__wrapper');
  const fixedHeaderHeight = 42;//固定ヘッダーの高さ
  
  // 固定対象の高さを取得
  let categoryLinklistsHeight = 0;
  let mobileFacetsButtonHeight = 0;
  let categoryLinklistsOffset = 0;
  let mobileFacetsButtonOffset = 0;
  if (categoryLinklists.length) {
    categoryLinklistsHeight = categoryLinklists.outerHeight();//カテゴリのリンクリストの高さ
    categoryLinklistsOffset = categoryLinklists.offset().top;
  }
  if (mobileFacetsButton.length) {
    mobileFacetsButtonHeight = mobileFacetsButton.outerHeight();//絞り込みボタンの高さ
    mobileFacetsButtonOffset = mobileFacetsButton.offset().top;
  }
  // 固定開始位置（固定ヘッダーの高さ / 絞り込みボタンの位置）
  const categoryLinklistsPosition = categoryLinklistsOffset - fixedHeaderHeight;
  const mobileFacetsButtonPosition = mobileFacetsButtonOffset - categoryLinklistsHeight - fixedHeaderHeight;
  // 固定対象のtopの値
  const categoryLinklistsTop = fixedHeaderHeight;
  const mobileFacetsButtonTop = categoryLinklistsTop + categoryLinklistsHeight;

  let prevY = window.pageYOffset; // 前回のスクロール位置を初期化
  let prevmY = window.pageYOffset; // 前回のスクロール位置を初期化

  $( window ).on( 'scroll', function() {
    if (categoryLinklists.length) {
      // カテゴリのリンクリストまでスクロールしたら、上部固定
      if ( categoryLinklistsPosition < $( this ).scrollTop() ) {
        $( '#MainContent' ).css( 'padding-top', categoryLinklistsHeight );
        categoryLinklists.addClass( 'is_m_fixed' ).css({'top': categoryLinklistsTop });

        if ($( this ).scrollTop() < prevY) { // 上にスクロールしている場合
          categoryLinklists.removeClass('hidden'); // hiddenクラスを削除して表示する
        } else { // 下にスクロールしている場合
          if ($( this ).scrollTop() > 0) { //Safariなどのバウンススクロール対策
            categoryLinklists.addClass('hidden'); // hiddenクラスを追加して非表示にする
          }
        }
        prevY = $( this ).scrollTop(); // 前回のスクロール位置を更新

        // カテゴリのリンクリストの位置に達してなければ、何もしない
      } else {
        $( '#MainContent' ).css( 'padding-top', 0 );
        categoryLinklists.removeClass( 'is_m_fixed' ).css({'top': 0 });
      }
    }
    //if (mobileFacetsButton.length) {
    //  // 絞り込みボタンまでスクロールしたら、上部固定
    //  if (mobileFacetsButtonPosition < $(this).scrollTop()) {
    //    $('#MainContent').css('padding-top', mobileFacetsButtonHeight);
    //    mobileFacetsButton.addClass('is_m_fixed').css({
    //      'top': mobileFacetsButtonTop
    //    });

    //    if ($(this).scrollTop() < prevmY) { // 上にスクロールしている場合
    //      mobileFacetsButton.removeClass('hidden'); // hiddenクラスを削除して表示する
    //    } else { // 下にスクロールしている場合
    //      if ($(this).scrollTop() > 0) { //Safariなどのバウンススクロール対策
    //        mobileFacetsButton.addClass('hidden'); // hiddenクラスを追加して非表示にする
    //      }
    //    }
    //    prevmY = $(this).scrollTop(); // 前回のスクロール位置を更新

    //    // 絞り込みボタンの位置に達してなければ、何もしない
    //  } else {
    //    if (categoryLinklistsPosition >= $(this).scrollTop()) {
    //      $('#MainContent').css('padding-top', 0);
    //    }
    //    mobileFacetsButton.removeClass('is_m_fixed').css({
    //      'top': 0
    //    });
    //  }
    //}
  });

}


/*
 * ページ上部にスクロールするボタン
 */
function scrollPagetop(){
  const pagetopButton = '.js-pagetop-button';//ページ上部に戻るボタン
  //クリックしたらページ上部に自動スクロール
  $(pagetopButton).on('click', function (){
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  });
}

/*
 * 特定のエリアでカーソル変更（マウスストーカー）
 */
function customizeCursorOnHover (area, cursor){  
  //カーソルエリアの指定
  const thisArea = $(area);
  const thisCursor = $(cursor);

  //mousemoveイベントでカーソル要素を移動させる
  thisArea.on( "mousemove", function(event){
    //常時に非表示にしているので、エリア内に来たらカーソル要素を表示
    thisCursor.show();
    //カーソルの座標位置を取得
    const cursorX = event.clientX;
    const cursorY = event.clientY;
    //カーソル要素のcssを書き換える用
    thisCursor.css({
      "opacity":"1",
      "transform": "translate(" + cursorX + "px," + cursorY + "px) ",
    });
  });
  
  //エリアからマウスを外すと、カーソル要素を非表示
  thisArea.on( 'mouseleave', function(){
    thisCursor.hide();
  });
}

/*
 * グローバルナビゲーション制御
 */
function controlGlobalNavigation() {
  // PC
  const pcMenuBtn = $('#nav-pc-toggle');//ハンバーガーメニュー
  const pcMenuContent = $('#gnav-drawer');//メニュー内コンテンツ
  const pcSubmenuBtn = $('.js-gnav-submenu-toggle');//サブメニューボタン
  const pcSubmenu = $('.js-gnav-submenu');//サブメニュー内のコンテンツ
  const pcSubsubmenuBtn = $('.js-gnav-subsubmenu-toggle');//subサブメニューボタン
  const pcSubsubmenu = $('.js-gnav-subsubmenu');//subサブメニュー内のコンテンツ

  //メニューボタンをタップしたら、メニューを展開
  pcMenuBtn.on('click', function(){
    //閉じてる場合は展開する
    if($(this).hasClass('is-open')) {
      $(this).removeClass('is-open');
      pcMenuContent.removeClass('is-open');
      pcSubmenuBtn.removeClass('is-sub-open');
      pcSubmenu.removeClass('is-sub-open');
      pcSubsubmenuBtn.removeClass('is-sub-open');
      pcSubsubmenu.removeClass('is-sub-open');
      $('body').removeClass('is-pc-menu-open');
    //展開されてたら閉じる
    } else {
      $(this).addClass('is-open');
      pcMenuContent.addClass('is-open');
      $('body').addClass('is-pc-menu-open');
    }
  });

  //子カテゴリを開くメニュー時も同様の制御
  pcSubmenuBtn.on('click', function(){
    if($(this).hasClass('is-sub-open')) {
      $(this).removeClass('is-sub-open');
      pcSubmenu.removeClass('is-sub-open');
      pcSubsubmenuBtn.removeClass('is-sub-open');
      pcSubsubmenu.removeClass('is-sub-open');
    } else {
      pcSubmenuBtn.removeClass('is-sub-open');
      pcSubmenu.removeClass('is-sub-open');
      pcSubsubmenuBtn.removeClass('is-sub-open');
      pcSubsubmenu.removeClass('is-sub-open');
      $(this).addClass('is-sub-open');
      $(this).siblings('.js-gnav-submenu').addClass('is-sub-open');
    }
  });

  //3階層目を開くメニュー時も同様の制御
  pcSubsubmenuBtn.on('click', function(){
    if($(this).hasClass('is-sub-open')) {
      $(this).removeClass('is-sub-open');
      pcSubsubmenu.removeClass('is-sub-open');
    } else {
      pcSubsubmenuBtn.removeClass('is-sub-open');
      pcSubsubmenu.removeClass('is-sub-open');
      $(this).addClass('is-sub-open');
      $(this).siblings('.js-gnav-subsubmenu').addClass('is-sub-open');
    }
  });

  // 閉じる処理
  $(document).on('click', function(event) {
    if($('body').hasClass('is-pc-menu-open')){
      if(!$(event.target).closest('.gnav-container').length) {
        //ここに外側をクリックしたときの処理
        pcMenuBtn.removeClass('is-open');
        pcMenuContent.removeClass('is-open');
        $('body').removeClass('is-pc-menu-open');
        pcSubmenuBtn.removeClass('is-sub-open');
        pcSubmenu.removeClass('is-sub-open');
        pcSubsubmenuBtn.removeClass('is-sub-open');
        pcSubsubmenu.removeClass('is-sub-open');
      } else {
        //ここに内側をクリックしたときの処理
      }
    }
  });  

  // スマホ用
  const spMenuBtn = $('#nav-sp-toggle');//ハンバーガーメニュー
  const spMenuContent = $('#menu-drawer');//メニュー内コンテンツ
  const spSubBackButton = $('.menu-drawer__close-button');//閉じるボタン

  spMenuBtn.on('click', function(){
    if($(this).hasClass('is-open')) {
      $(this).removeClass('is-open');
      spMenuContent.removeClass('is-open');
      spSubBackButton.parents('details').removeAttr('open');
      $('body').removeClass('is-sp-menu-open');
    } else {
      $(this).addClass('is-open');
      spMenuContent.addClass('is-open');
      $('body').addClass('is-sp-menu-open');
    }
  });

  spSubBackButton.on('click', function(){
    $(this).closest('details').removeAttr('open');
  });

  // 閉じる処理
  $(document).on('click', function(event) {
    // メニューが開いている場合のみ処理を実行
    if (spMenuContent.hasClass('is-open')) {
      // クリックされた要素がハンバーガーメニューボタン、またはメニューコンテンツ内に含まれていないかを確認
      // contains() は要素が別要素の子孫であるかを確認する
      if (!$(event.target).closest('#menu-drawer').length && !$(event.target).closest('#nav-sp-toggle').length) {
        // どちらにも含まれていなければメニューを閉じる
        spMenuBtn.removeClass('is-open');
        spMenuContent.removeClass('is-open');
        spSubBackButton.parents('details').removeAttr('open');
        $('body').removeClass('is-sp-menu-open');
      }
    }
  });

  //// ヘッダのキーワードをSPナビに複製
  //const searchKeywordElm = $('.js-search-keyword-items');
  //searchKeywordElm.clone().appendTo('.js-sp-nav-kw');
}

/*
 * 画面下部のメニューの表示制御
 */
//function controlSpBottomNavFixed(){
//  const spBottomNav = $('.nav-sp-container');//スマホの画面下部のメニュー
//  const scrollPosition =  $(window).scrollTop();//スクロールポジション
//  const documentHeight = $(document).height();//ドキュメントの高さ
//  const windowHeight = $(window).height(); //windowの高さ
//  const footerHeight = 100;//フッター
    
//  //フッターまで行ったら位置変更
//  if (documentHeight - windowHeight - scrollPosition <= footerHeight) {
//    spBottomNav.addClass('is-stop');
//  } else {
//    spBottomNav.removeClass('is-stop');
//  }
//}

/*
 * 商品バリエーション情報の更新
 */
function updateVariationCustomInfo() {
  const currentUrl = window.location.href;
  //SKUを選択しても在庫情報は切り替わらず、維持されてしまう。SKUに紐づく在庫表示に切り替えるため、在庫情報のHTMLのみロードする
  $( "#variant-zaiko-status-wrap" ).load(currentUrl + " #variant-zaiko-status");
}

/*
 * LIMITEDの画像切り替え
*/
function limitedImgaeSlide(){
  const mySwiper = new Swiper('.limited-swiper', {
    loop: true,
    effect: 'fade',
    speed: 1000, // 少しゆっくり(デフォルトは300)
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
  });
}

/*
 * 外部リンクアニメーション
*/
function externaLinkAnimation() {
  //外部リンク
  const $externaLink = $('.menu_http_link, .http_link,.faq-link,.open_link');

  //マウスが要素の上に乗ったら、アニメーションを発火
  if ($externaLink.length > 0) {
    $externaLink.one('mouseenter', function() {
      $(this).addClass('is-hover');
    });
  }  
}

/*
 * FAQのコンテンツの開閉処理
*/
function toggleFaqContents(){
  //クエスチョンをクリックで、アンサーの表示・非表示を切り替え
  $(".faq-q").click(function(){
    $(this).toggleClass('is-open');
    $(this).next(".faq-a").slideToggle();
  });
}

/*
 * 問い合わせフォームにメッセージをセット
*/
function setProductInfoToMessage() {
  var params = Util.getQueryParams();
  var productHandle = params['product_handle'];
  var productName = params['product_name'];
  var message = '';
  if (productHandle && productHandle !== undefined) {
    message += decodeURI(productHandle);
    message += '\n';
  }
  if (productName && productName !== undefined) {
    message += decodeURI(productName);
    message += '\n';
  }
  $("#ContactForm-body").val(message);
}

// スクロールのドラッグ有効化
jQuery.prototype.mousedragscrollable = function () {
  let target;
  $(this).each(function (i, e) {
    $(e).mousedown(function (event) {
      event.preventDefault();
      target = $(e);
      $(e).data({
        down: true,
        move: false,
        x: event.clientX,
        y: event.clientY,
        scrollleft: $(e).scrollLeft(),
        scrolltop: $(e).scrollTop(),
      });
      return false;
    });
    $(e).click(function (event) {
      if ($(e).data("move")) {
        return false;
      }
    });
  });
  $(document)
    .mousemove(function (event) {
      if ($(target).data("down")) {
        event.preventDefault();
        let move_x = $(target).data("x") - event.clientX;
        let move_y = $(target).data("y") - event.clientY;
        if (move_x !== 0 || move_y !== 0) {
          $(target).data("move", true);
        } else {
          return;
        }
        $(target).scrollLeft($(target).data("scrollleft") + move_x);
        $(target).scrollTop($(target).data("scrolltop") + move_y);
        return false;
      }
    })
    .mouseup(function (event) {
      $(target).data("down", false);
      return false;
    });
};

// ギフトラッピングのトグル
function cartToggleBtns() {
  $('.cart-toggle-contents').addClass('hidden');
  $('.cart-toggle-container').each(function () {
    const toggleSwitch = $(this).find('.cart-toggle-heading');
    const toggleContents = $(this).find('.cart-toggle-contents');
    toggleSwitch.on('click', function () {
      if (toggleSwitch.hasClass('active')) {
        toggleContents.addClass('hidden')
        toggleSwitch.removeClass('active');
      } else {
        toggleContents.removeClass('hidden')
        toggleSwitch.addClass('active');
      }
    });
  });
}

/*====================================
  商品詳細ページ　店舗在庫ボタン
====================================*/
// product.variants から取得したデータは Liquid で <script> タグ内に `allVariantsData` として定義

// DOMの読み込みが完了したら実行
$(document).ready(function() {
  var $storeStockButton = $('#store-stock-button');
  var $productForm = $('form[action="/cart/add"]');
  var baseUrl = 'https://hervechapelier-member.com/stock/list?t=bc71cee3a3b9074b&SKU=';

  // ボタンまたはフォームが見つからない場合は処理を中断
  if (!$storeStockButton.length || !$productForm.length) {
    return;
  }

  // バリエーション変更時
  $productForm.on('change', 'select[name="id"], input[name="id"]', function() {
    var selectedVariantId = $(this).val();

    // 選択されたバリエーションのIDを使って、allVariantsDataから対応するバーコードを探す
    var selectedVariant = allVariantsData.find(variant => String(variant.id) === String(selectedVariantId));

    if (selectedVariant && selectedVariant.barcode) {
      // バーコードがある場合
      $storeStockButton.attr('href', baseUrl + selectedVariant.barcode);
      $storeStockButton.show(); // ボタンを表示
    } else {
      // バーコードがない場合
      $storeStockButton.hide(); // ボタンを非表示
      // 必要に応じて、hrefも更新（例: # にするなど）
      $storeStockButton.attr('href', '#');
    }
  });

  // 初期ロード時にもバーコードの有無を確認し、ボタンの表示を調整
  var initialSelectedVariantId = $productForm.find('select[name="id"], input[name="id"]').val();
  var initialSelectedVariant = allVariantsData.find(variant => String(variant.id) === String(initialSelectedVariantId));

  if (initialSelectedVariant && initialSelectedVariant.barcode) {
    $storeStockButton.attr('href', baseUrl + initialSelectedVariant.barcode);
    $storeStockButton.show();
  } else {
    $storeStockButton.hide();
    $storeStockButton.attr('href', '#');
  }
});

//about LP

//------------------------------------------------//
// Layout Scaling System
//------------------------------------------------//
const aboutLp = document.querySelector('.aboutlp');

const DESIGN_PC = 1400;
const DESIGN_PC_FONT = 10;
const MIN_FONT_SIZE = 10;

function updateRem() {
  if (!aboutLp) return;

  const winW = window.innerWidth;

  // SPは除外
  if (winW <= 750) {
    aboutLp.style.fontSize = '';
    aboutLp.style.removeProperty('--scale');
    return;
  }

  const scaleValue = `calc(${100 / DESIGN_PC} * 1vw)`;
  aboutLp.style.setProperty('--scale', scaleValue);

  let fontPx = (winW / DESIGN_PC) * DESIGN_PC_FONT;

  if (fontPx < MIN_FONT_SIZE) {
    fontPx = MIN_FONT_SIZE;
  }

  aboutLp.style.fontSize = `${fontPx}px`;
}

updateRem();

window.addEventListener('resize', updateRem);

//------------------------------------------------//
// MV Scroll Animation
//------------------------------------------------//
document.addEventListener('DOMContentLoaded', () => {

  const targets = document.querySelectorAll('.js-aboutlp-mv');

  if (!targets.length) return;

  const handleScroll = () => {

    targets.forEach((target) => {

      // 100vhスクロールしたら
      if (window.scrollY > window.innerHeight) {
        target.classList.add('is-move');
      } else {
        target.classList.remove('is-move');
      }

      const rect = target.getBoundingClientRect();

      // 要素の下端が画面内に入ったら
      if (rect.bottom <= window.innerHeight) {
        target.classList.add('is-end');
      } else {
        target.classList.remove('is-end');
      }

    });

  };

  // 初回実行
  handleScroll();

  // scrollイベント
  window.addEventListener('scroll', handleScroll);

});


//------------------------------------------------//
// Swiper
//------------------------------------------------//
document.addEventListener('DOMContentLoaded', () => {

  // Swiper未読込対策
  if (typeof Swiper === 'undefined') return;

  let resizeTimer;

  function initSwiperIfNeeded() {

    const isSp = window.innerWidth <= 750;

    const swiperContainers = document.querySelectorAll('.js-aboutlp-swiper');

    swiperContainers.forEach((container) => {

      const space = Number(container.dataset.space) || 8;

      const viewAttr = container.dataset.view;

      const width = Number(container.dataset.width) || 240;

      // view指定があれば枚数指定
      // 無ければ auto
      const slidesPerView = viewAttr
        ? Number(viewAttr)
        : 'auto';

      // auto時だけCSS変数をセット
      if (slidesPerView === 'auto') {
        container.style.setProperty(
          '--slide-width',
          `${width}px`
        );
      }

      // SP時のみ生成
      if (isSp && !container.swiperInstance) {

        container.swiperInstance = new Swiper(container, {
          slidesPerView,
          speed: 300,
          loop: false,
          spaceBetween: space,
        });

      }

      // PC時は破棄
      else if (!isSp && container.swiperInstance) {

        container.swiperInstance.destroy(true, true);

        container.swiperInstance = null;

      }

    });

  }

  // 初回
  initSwiperIfNeeded();

  // resize
  window.addEventListener('resize', () => {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      initSwiperIfNeeded();
    }, 200);

  });

});

//------------------------------------------------//
// Random
//------------------------------------------------//
document.addEventListener('DOMContentLoaded', () => {

  const container = document.querySelector('.js-random');

  if (!container) return;

  let items = Array.from(
    container.querySelectorAll('.aboutlp-color-value-box')
  );

  // Fisher-Yates Shuffle
  for (let i = items.length - 1; i > 0; i--) {

    const j = Math.floor(Math.random() * (i + 1));

    [items[i], items[j]] = [items[j], items[i]];

  }

  // ブレークポイント
  const breakpoint = 749;

  // スマホ: 5個 / PC: 5個
  const groupSize = window.innerWidth <= breakpoint ? 5 : 5;

  //------------------------------------------------//
  // 30個未満ならランダム複製で埋める
  //------------------------------------------------//
  const minCount = 30;

  if (items.length < minCount) {

    const need = minCount - items.length;

    for (let i = 0; i < need; i++) {

      const randomIndex = Math.floor(Math.random() * items.length);

      const clone = items[randomIndex].cloneNode(true);

      items.push(clone);

    }

  }

  //------------------------------------------------//
  // groupSize の倍数になるように埋める
  //------------------------------------------------//
  const remainder = items.length % groupSize;

  if (remainder !== 0) {

    const need = groupSize - remainder;

    for (let i = 0; i < need; i++) {

      const randomIndex = Math.floor(Math.random() * items.length);

      const clone = items[randomIndex].cloneNode(true);

      items.push(clone);

    }

  }

  // PC判定
  const isPc = window.innerWidth > breakpoint;

  // PCで30個を超えたらランダム削除
  if (isPc && items.length > 30) {

    // シャッフル
    items = items.sort(() => Math.random() - 0.5);

    // 30個に制限
    items = items.slice(0, 30);

  }

  // 一旦クリア
  container.innerHTML = '';

  // グループ化
  for (let i = 0; i < items.length; i += groupSize) {

    const group = document.createElement('div');

    group.classList.add('swiper-slide');

    items.slice(i, i + groupSize).forEach((item) => {
      group.appendChild(item);
    });

    container.appendChild(group);

  }

});


//------------------------------------------------//
// Modal
//------------------------------------------------//

const modalButtons = document.querySelectorAll('.js-modal-button');

// 開く
modalButtons.forEach(btn => {
  btn.addEventListener('click', function () {
    const modalId = this.dataset.modal;
    const modal = document.getElementById(modalId);

    if (modal) {
      modal.classList.add('is-modal-show');
    }
  });
});

// 各モーダルごとに処理
const modals = document.querySelectorAll('.js-modal');

modals.forEach(modal => {
  const modalContent = modal.querySelector('.js-modal-content');
  const modalClose = modal.querySelector('.js-modal-close');

  // 閉じるボタン
  if (modalClose) {
    modalClose.addEventListener('click', function () {
      modal.classList.remove('is-modal-show');
    });
  }

  // 外側クリック
  modal.addEventListener('click', function (e) {
    if (!modalContent.contains(e.target)) {
      modal.classList.remove('is-modal-show');
    }
  });
});

//------------------------------------------------//
// Cursor
//------------------------------------------------//

window.addEventListener("load", () => {

  // タッチ端末除外
  if ("ontouchstart" in window || navigator.maxTouchPoints) {
    return;
  }

  customizeCursorOnHover(
    ".js-cursor-detail-area",
    ".js-cursor-detail"
  );

});

function customizeCursorOnHover(area, cursor) {

  const areas = document.querySelectorAll(area);
  const thisCursor = document.querySelector(cursor);

  if (!areas.length || !thisCursor) return;

  areas.forEach((thisArea) => {

    thisArea.addEventListener("mousemove", (event) => {

      const cursorX = event.clientX;
      const cursorY = event.clientY;

      thisCursor.style.display = "flex";

      thisCursor.style.transform =
        `translate(${cursorX}px, ${cursorY}px) translate(-50%, -50%)`;

    });

    thisArea.addEventListener("mouseleave", () => {
      thisCursor.style.display = "none";
    });

  });

}

/*
 * 商品詳細ページの支払い方法、配送と返品、ラッピングをドロワー表示
 */
function initProductDetailDrawer(){
  const $drawers = $('.custom-drawer');
  const $overlay = $('.custom-drawer-overlay');

  // ドロワーを開く関数
  const openDrawer = (drawerId) => {
    const $targetDrawer = $('#' + drawerId);
    if (!$targetDrawer.length) return;

    $drawers.removeClass('is-active');

    $targetDrawer.addClass('is-active').attr('aria-hidden', 'false');
    $overlay.addClass('is-active');

    // 背景スクロール禁止 ＆ bodyにクラス付与（ヘッダー制御用）
    $('body').css('overflow', 'hidden').addClass('drawer-open');
  };

  // ドロワーを閉じる関数
  const closeDrawer = () => {
    $drawers.removeClass('is-active').attr('aria-hidden', 'true');
    $overlay.removeClass('is-active');

    // スクロール解除 ＆ クラス解除
    $('body').css('overflow', '').removeClass('drawer-open');
  };

  // トリガークリック時
  $('.js-drawer-trigger').on('click', function (e) {
    e.preventDefault();
    const targetId = $(this).data('drawer-target'); // data-drawer-targetを取得
    openDrawer(targetId);
  });

  // 閉じるボタンクリック時
  $('.js-drawer-close').on('click', closeDrawer);
}

/*
 * 商品詳細ページの商品について、お手入れ方法、サイズ・仕様注意事項をトグル化
 */
function initProductAccordionToggle(){
  $('.js-accordion-toggle').on('click', function() {
    var $header = $(this);
    var $parent = $header.closest('.product-accordion-item');
    var $content = $header.next('.product-accordion-content');

    // 他を閉じる処理を削除し、クリックされた要素だけを開閉
    $parent.toggleClass('active');
    $content.stop().slideToggle(300);
  });
}